import AltRouteRoundedIcon from '@mui/icons-material/AltRouteRounded';
import ExploreRoundedIcon from '@mui/icons-material/ExploreRounded';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ListAltRoundedIcon from '@mui/icons-material/ListAltRounded';
import PictureAsPdfRoundedIcon from '@mui/icons-material/PictureAsPdfRounded';
import { Button, Divider, Stack, Typography } from '@mui/material';
import { FC, memo } from 'react';

type Props = {
  printAllOperationDirectionsOnClick: () => void;
  printAllTruckDirectionsOnClick: () => void;
  printUnloadTruckDirectionsOnClick: () => void;
  printPickingListOnClick: () => void;
  downloadPlanCsvPerPacketOnClick: () => void;
  downloadPlanCsvPerPlaceOnClick: () => void;
}

const SelectPrintPresenter: FC<Props> = memo((
  {
    printAllOperationDirectionsOnClick,
    printAllTruckDirectionsOnClick,
    printUnloadTruckDirectionsOnClick,
    printPickingListOnClick,
    downloadPlanCsvPerPacketOnClick,
    downloadPlanCsvPerPlaceOnClick
  }
) => (
  <Stack p={2} spacing={1}>
    <Stack>
      <Typography>
        出力形式を選択してください
      </Typography>
    </Stack>
    <Stack divider={<Divider />} spacing={1}>
      <Stack>
        <Button
          onClick={printAllOperationDirectionsOnClick}
          startIcon={<ExploreRoundedIcon />}
          endIcon={<PictureAsPdfRoundedIcon />}
        >
          配送指示書
        </Button>
      </Stack>
      <Stack>
        <Button
          onClick={printPickingListOnClick}
          startIcon={<ListAltRoundedIcon />}
          endIcon={<PictureAsPdfRoundedIcon />}
        >
          ピッキングリスト
        </Button>
      </Stack>
      <Stack>
        <Button
          onClick={downloadPlanCsvPerPacketOnClick}
          startIcon={<AltRouteRoundedIcon />}
          endIcon={<FileDownloadIcon />}
        >
          配車CSVダウンロード（商品毎）
        </Button>
        <Button
          onClick={downloadPlanCsvPerPlaceOnClick}
          startIcon={<AltRouteRoundedIcon />}
          endIcon={<FileDownloadIcon />}
        >
          配車XLSXダウンロード（地点毎）
        </Button>
      </Stack>
    </Stack>
  </Stack>
  ));

export default SelectPrintPresenter;
